import { Span, MultilineInput } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Human } from "../../../Models/Human";
import { PaymentForm, PaymentFormNames } from "../../../Models/Payment/PaymentForm";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PaymentStepData } from "../Models/PaymentStepData";


export class PaymentReturnInfoForAdmin extends Table
{
    constructor(payment: PaymentStepData, customer?: Human)
    {
        super();
        this.Class("payment-info-table");

        const customerAccountNumber = payment.AccountNumber.value || customer?.BankAccountNumber?.value || "⚠️ brak numeru konta";

        this.AddRow("Forma", PaymentFormNames[payment.Form.value])
            .AddRow("Tytułem", payment.Title.value)
            .AddRow("Kwota", payment.AmountAsString)

        switch (payment.Form.value)
        {
            default:
            case PaymentForm.BankTransfer:
                this.AddRow("Numer konta", customerAccountNumber)
                    .AddRow("Dane do przelewu", (customer?.Name?.value || "---") + "\n" + (customer?.Address?.value || "---"))
                break;

            case PaymentForm.Blik:
                this.AddRow("Z numeru", customer?.Phone?.value || "---")
                    .AddRow("Z konta", customerAccountNumber)
                    .AddRow("Nazwisko", customer?.Name?.value || "---")
                break;

            case PaymentForm.Cash:
                break;

            case PaymentForm.Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Do przelania", new Span(btcAmount + " " + payment.PaymentCurrency.value).Bold())
                    .AddRow("Kurs BTC", payment.ExchangeRate.value + " PLN za 1 BTC")
                    .AddRow("Adres portfela", new MultilineInput(customerAccountNumber).Readonly().Rows(3).Background("none").BorderNone().Padding(0).Margin(0).Color("#000"))
                break;
        }

        this.AddRow("Termin", "do " + TimeUtils.FormattedDate(payment.Deadline.value));
    }
}
